import React from "react";

import Text from "../Text";
// import { ExternalAnchor } from "../Anchor";
import {
  StyledFooter,
  // SocialLinksContainer,
  FooterContainer,
  LogoWrapper,
  FooterContent,
  // HideOnMobile,
  ShowOnMobile,
} from "./styled";
// import Icon from "../Icon";
// import { FOOTER_SOCIAL_LINKS } from "./constants";
import { Row } from "../QuineGrid";
// import isMobile from "../../utils/isMobile";
import Image from "next/image";
// import QUINE_LINKS from "../../constants/links";

const Footer: React.FC<{
  isDark?: boolean;
}> = ({ isDark = false }) => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <Row centered>
        <StyledFooter $isDark={isDark}>
          {/* <HideOnMobile>
            <ExternalAnchor
              className=""
              href={QUINE_LINKS.quiraStatus}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Text
                color={isDark ? "green20" : "currentColor"}
                size="14px"
                margin="0 2px 0 0"
              >
                Check Quira status{" "}
              </Text>
              <Icon
                name="externalLink"
                size="16px"
                color={isDark ? "green20" : "currentColor"}
                isInline
                margin="3px 0 0 0"
              />
            </ExternalAnchor>
          </HideOnMobile> */}
          <FooterContent>
            <LogoWrapper>
              <Image
                src={
                  isDark
                    ? "/images/quira-logo-white.svg"
                    : "/images/quira-logo.svg"
                }
                alt="Quira logo"
                width={100}
                height={22}
                loading="eager"
              />
              <ShowOnMobile>
                {/* <ExternalAnchor
                  href={QUINE_LINKS.quiraStatus}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Text color={isDark ? "green20" : "currentColor"} size="14px">
                    Check Quira status{" "}
                  </Text>
                  <Icon
                    name="externalLink"
                    size="16px"
                    color={isDark ? "green20" : "currentColor"}
                    isInline
                    margin="0 0 0 4px"
                  />
                </ExternalAnchor> */}
                {/* <SocialLinksContainer $isDark={isDark}>
                  {FOOTER_SOCIAL_LINKS.map((socialLink, idx) => (
                    <ExternalAnchor key={idx} href={socialLink.href}>
                      <Icon
                        name={socialLink.icon}
                        size="24px"
                        color="currentColor"
                      />
                    </ExternalAnchor>
                  ))}
                </SocialLinksContainer> */}
              </ShowOnMobile>
              <Text color="currentColor" alignText="left">
                © {currentYear} Quira LTD.
                <br />
                Built remotely. Designed in London.
              </Text>
            </LogoWrapper>
            {/* <HideOnMobile>
              <SocialLinksContainer $isDark={isDark}>
                {FOOTER_SOCIAL_LINKS.map((socialLink, idx) => (
                  <ExternalAnchor key={idx} href={socialLink.href}>
                    <Icon
                      name={socialLink.icon}
                      size="24px"
                      color="currentColor"
                    />
                  </ExternalAnchor>
                ))}
              </SocialLinksContainer>
            </HideOnMobile> */}
          </FooterContent>
        </StyledFooter>
      </Row>
    </FooterContainer>
  );
};

export default Footer;
